// i18n
import { translateInComponent } from 'infras/i18n';
import translations from './i18n.json';

import { SyntheticEvent } from 'react';
import Link from 'presentations/views/components/atoms/Link';
import styled from '@emotion/styled';
import EventTypeSubmitField from 'presentations/views/components/molecules/EventTypeSubmitField';
import PaymentDetail from 'presentations/views/components/molecules/PaymentDetail';
import { spacing, mediaMax, fontSize } from 'presentations/views/styles';
import { Trail } from '../../atoms/Transition';
import { black, white } from 'presentations/views/styles/color';
import { EventTypeServiceListItem } from 'presentations/api/schema/event_type_service';
import { SharedEventTypeItem } from 'presentations/api/schema/event_type';
import { DateTime } from 'infras/datetime';
import {
  eventTypeCancelPolicyPath,
  eventTypeTermPath,
} from 'presentations/routes/path';
import { PaymentMethod } from 'domains/models/event_payment/payment_method';
import {
  EventPaymentItem,
  toLineItem,
} from 'presentations/api/schema/event_payment';
import EventPayment from 'domains/models/event_payment';
import { Currency } from 'domains/models/service_price/currency';

export type Props = {
  onClick?: any;
  onSubmit?: any;
  isLoading?: boolean;
  isDisabled: boolean;
  color: string;
  isLightColor: boolean;
  eventType: SharedEventTypeItem;
  selectedServices: EventTypeServiceListItem[];
  selectedDatetime: DateTime;
  selectedPaymentMethod: PaymentMethod;
  timeZone: string;
  teamSlug: string;
};

export default function Component(props: Props) {
  const t = translateInComponent(translations);
  let currency: Currency | null = null;
  for (const service of props.eventType.services) {
    if (service.price?.currency) {
      currency = service.price.currency;
      break;
    }
  }

  const items = props.selectedServices.map((s) => toLineItem(s, currency!));
  const eventPayment: EventPaymentItem = {
    paymentMethod: props.selectedPaymentMethod,
    totalAmount: 0,
    items,
    currency,
    stripePaymentIntentId: null,
    receiptUrl: null,
  };
  eventPayment.totalAmount = new EventPayment(eventPayment).calcTotalAmount();

  const eventEndedAt = props.selectedDatetime.plus({
    minute: props.eventType.duration,
  });

  const submitLabel = props.eventType.setting.isBookingRequest
    ? t('pay 0')
    : t(`pay ${props.selectedPaymentMethod}`);

  return (
    <Form>
      <Trail isOpen={true}>
        <Block>
          <PaymentDetail
            isNoBorder={true}
            isShowSchedule={true}
            isShowPaymentMethodOnly={false}
            eventPayment={eventPayment}
            startDatetime={props.selectedDatetime}
            endDatetime={eventEndedAt}
            timeZone={props.timeZone}
          />
          <TermDescription>
            {t('policy description.0')}
            <Link
              href={eventTypeTermPath(props.teamSlug, props.eventType.slug)}
              onClick={(e: SyntheticEvent) =>
                props.onClick(
                  e,
                  eventTypeTermPath(props.teamSlug, props.eventType.slug),
                )
              }
              target="_blank"
            >
              {t('policy description.1')}
            </Link>
            {t('policy description.2')}
            <Link
              href={eventTypeCancelPolicyPath(
                props.teamSlug,
                props.eventType.slug,
              )}
              onClick={(e: SyntheticEvent) =>
                props.onClick(
                  e,
                  eventTypeCancelPolicyPath(
                    props.teamSlug,
                    props.eventType.slug,
                  ),
                )
              }
              target="_blank"
            >
              {t('policy description.3')}
            </Link>
            {t('policy description.4')}
          </TermDescription>
        </Block>
      </Trail>
      <Submit>
        <EventTypeSubmitField
          isLoading={props.isLoading}
          submitLabel={submitLabel}
          onSubmit={props.onSubmit}
          isDisabled={props.isDisabled}
          color={props.color}
          isLightColor={props.isLightColor}
        />
      </Submit>
    </Form>
  );
}

const Block = styled.div`
  margin-bottom: ${spacing(32)};
  :last-of-type {
    /* margin-bottom: 0; */
  }
`;

const Submit = styled.div`
  bottom: 0;
  left: 0;
  width: 100%;
  height: 70px;
  margin-bottom: ${spacing(16)};
  background-color: ${white};
  ${mediaMax.smartphone} {
    position: inherit;
  }
`;

const Form = styled.div`
  display: block;
  width: 100%;
  position: relative;
  padding: 0 ${spacing(16)} 0;
  ${mediaMax.smartphone} {
    height: inherit;
    padding: ${spacing(8)} ${spacing(16)} 0;
  }
`;
const TermDescription = styled.div`
  font-size: ${fontSize(14)};
  color: ${black};
  padding: 0 ${spacing(24)} 0;
`;
